import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { adminMe, isAdminAuthenticated } from '../../lib/admin';

/**
 * Protects an admin route: redirects to /admin/login if not authenticated.
 * Validates token against backend (so deleted/expired tokens are rejected).
 */
export default function ProtectedAdminRoute({ children }) {
  const [state, setState] = useState('checking'); // 'checking' | 'ok' | 'redirect'

  useEffect(() => {
    if (!isAdminAuthenticated()) {
      setState('redirect');
      return;
    }
    adminMe()
      .then(() => setState('ok'))
      .catch(() => setState('redirect'));
  }, []);

  if (state === 'checking') {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0e1e2e',
        color: '#fff',
        fontFamily: 'system-ui, sans-serif',
      }}>
        Verificando acceso…
      </div>
    );
  }
  if (state === 'redirect') {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
